import ModelService from "./abstract/ModelService";
import Depot from "../models/Depot";

const SYNCED_AT_HEADER = "x-synced-at";

export default class DepotService extends ModelService {
  constructor() {
    super("/depots", Depot);
  }

  /** Resolves { depots, syncedAt } — feed syncedAt back as only_changes_from. */
  searchSince(params = {}) {
    return this.postResponse(env.API_URL + "/depots/search", {
      params: { search: null, page: 1, ...params }
    }).then(resp => {
      const syncedAt = parseInt(resp.headers[SYNCED_AT_HEADER], 10);

      return {
        depots: Depot.list(resp.data),
        syncedAt: Number.isFinite(syncedAt) ? syncedAt : null
      };
    });
  }
}
